import { graphql } from '../../../../graphql/generated';

export const CREATE_ANALYSIS_STATION_MUTATION = graphql(`
  mutation CreateAnalysisStation($input: AnalysisStationCreateInput!) {
    createAnalysisStation(input: $input) {
      id
    }
  }
`);
